import { checkRoles } from "../functions/checkRoles";

/**
 * Роли модуля планирования (бэк: PlanRoles) + алиасы существующих ролей UI.
 */
export const planRoleGroups = {
  admin: ["SuperAdministrator", "Administrator"],
  planning: [
    "Planning",
    "Marketer",
    "Specialist",
    "Committee",
    "CommitteeAdministrator",
  ],
  performer: [
    "Performer",
    "LaboratoryAssistant",
    "LabAssistant",
    "NceExecutor",
    "Executor",
  ],
  sla: ["SLA", "Supervisor"],
  director: ["DSEKDirector", "Director"],
};

export const allPlanMenuRoles = [
  ...new Set([
    ...planRoleGroups.admin,
    ...planRoleGroups.planning,
    ...planRoleGroups.performer,
    ...planRoleGroups.sla,
    ...planRoleGroups.director,
  ]),
];

export const isPlanAdmin = () => checkRoles(...planRoleGroups.admin);

export const hasPlanRole = (...groups) => {
  if (isPlanAdmin()) return true;
  const roles = groups.flatMap((g) => planRoleGroups[g] || []);
  return roles.length ? checkRoles(...roles) : false;
};

export const canEditPlanRowsAtState = (stateId) => {
  const st = Number(stateId);
  if (st === 1) return hasPlanRole("planning");
  if (st === 5) return hasPlanRole("performer", "planning");
  return false;
};
